import { Directive, HostListener, Renderer2, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
@Directive({
  selector: '[trimInput]',
  standalone: false
})
export class TrimInputDirective {
  constructor(
    private ngModel: NgModel,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {}

  @HostListener('blur')
  onBlur() {
    let value = this.ngModel.model;
    if (value) {
      value = value.trim();
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
      this.renderer.setAttribute(this.elementRef.nativeElement, 'value', value);
      this.ngModel.update.emit(value);
    }
  }
}
